export default __webpack_public_path__ + "static/media/galeria_neue.031070e7.glb";